module.exports = __webpack_public_path__ + "6f1520d107205975713ba09df778f93f.ttf";